import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateV2 } from '../../../../../../../../helpers/datesAndTime.helper';
import { DueDateNotice } from '../../../../../../../../components/DueDateNotice';
import { IRecurringPaymentData } from '../../../../../../types';
import { ReactComponent as Icon } from '../../../../../../../../assets/icons/svg/shared/ic-shared-circled-switch.svg';
import { getBillRecurringEventTypeText, isOneTimeBill } from '../../../../../../BillDataUtils';
import { LiliTooltip } from '../../../../../../../../DesignSystem/LiliTooltip/LiliTooltip';

interface IDueDateRendererProps {
  billId: string;
  dueDate: string;
  status: string;
  paidTime: string;
  recurringPaymentData?: IRecurringPaymentData;
  isWidgetMode: boolean,
}

export const DueDateRenderer = ({
  billId, dueDate, status, paidTime, recurringPaymentData, isWidgetMode,
}: IDueDateRendererProps) => {
  const formattedDueDate = formatDateV2(dueDate, true);
  const { t } = useTranslation();
  const recurringText = recurringPaymentData ? `${recurringPaymentData?.recurringIndex} of ${recurringPaymentData?.recurringNumber}` : '';
  const billRecurringTitle = `${t('BILL_PAY.BILL_PREVIEW.RECURRING')}`;
  const tooltipId = `tool-tip-due-date-${billId}`;
  return (
    <div data-testid='BillsHub__table-column-due-date'>
      <div className='flex items-center gap-[10px]'>
        {`Due ${formattedDueDate}`}
        { recurringPaymentData && recurringPaymentData.paymentFrequency && !isOneTimeBill(recurringPaymentData.paymentFrequency) && (
        <div className='flex items-center gap-[4px]' data-tooltip-id={tooltipId} data-tooltip-delay-hide={0} data-tooltip-delay-show={100}>
          <Icon />
          { !isWidgetMode && recurringText}
        </div>
        )}
      </div>
      <DueDateNotice status={status} dueDate={dueDate} paidTime={paidTime} />
      {recurringPaymentData && recurringPaymentData.paymentFrequency && (
      <LiliTooltip
        description={`${billRecurringTitle}-${getBillRecurringEventTypeText(recurringPaymentData.paymentFrequency)}${isWidgetMode ? ` ${recurringText}` : ''}`}
        targetId={tooltipId}
      />
      )}
    </div>
  );
};
